// App.js
import React, { Suspense } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";

import Full from "./containers/Full/Full";

import Login from "./view/Login/Login";
import Logout from "./view/Logout/Logout";

import Landing from "./view/Register/Landing";
import CheckMobilNumber from "./view/Register/CheckMobilNumber";
import VerifyOTP from "./view/Register/VerifyOTP";
import Register from "./view/Register/Register";
import MemberDetial from "./view/Register/MemberDetial";

import Message from "./view/Broadcast/Message";
import Coupon from "./view/Broadcast/Coupon";
import Customer from "./view/Broadcast/post/Customer";
import ConfirmCustomer from "./view/Broadcast/post/ConfirmCustomer";
import SuccessCustomer from "./view/Broadcast/post/SuccessCustomer";

import DeliveryDetail from "./view/Delivery/Detail";

import "../src/assets/css/index.css";

export default function App() {
  return (
    <HashRouter>
      {/* ครอบด้วย Suspense เพื่อรองรับคอมโพเนนต์ที่ lazy อยู่ภายใน (เช่นใน Full) */}
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          {/* หน้าที่ไม่อยู่ใต้เลย์เอาต์ Full */}
          <Route exact path="/login" component={Login} />
          <Route exact path="/logout" component={Logout} />

          <Route exact path="/landing" component={Landing} />
          <Route exact path="/checkMobile" component={CheckMobilNumber} />
          <Route exact path="/verifyOtp" component={VerifyOTP} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/memberDetial" component={MemberDetial} />

          <Route exact path="/broadcast/messages" component={Message} />
          <Route exact path="/broadcast/coupon" component={Coupon} />
          <Route exact path="/broadcast/customer/:id" component={Customer} />
          <Route
            exact
            path="/broadcast/customer-confirm/:id"
            component={ConfirmCustomer}
          />
          <Route
            exact
            path="/broadcast/customer-success"
            component={SuccessCustomer}
          />
          <Route
            exact
            path="/broadcast/report-boardcast/:id"
            component={DeliveryDetail}
          />

          {/* ทั้งหมดที่ต้องมีเลย์เอาต์ Full (รวมโปรโมชันแบบ nested routes ภายใน Full) */}
          <Route path="/management" component={Full} />

          {/* default / ตกมา landing */}
          <Route path="/" component={Landing} />
        </Switch>
      </Suspense>
    </HashRouter>
  );
}
